export default __webpack_public_path__ + "a65002ffe91c5713da81eb4f24bae487.png";